import React from 'react';
import Router from './router/Router';
import 'bootstrap/dist/css/bootstrap.min.css';


function App() {
  return (
    <div className="App">
      <Router/>
    </div>
  );
}

export default App;